import {SERVER} from "../constants";
import {MAP_URL} from "../constants/urls";
import {FileUploader, HttpClient, SaveImage} from "../utils/requests";
import {fixUpdateBlogCategoryId} from "../panels/blogCategory/blogCategoryMapper";
import {fixUpdateAdviceId} from "../panels/advice/adviceMapper";
import {fixUpdateBlogId} from "../panels/blog/blogMapper";
import {fixUpdateConfigId} from "../panels/config/configMapper";
import {fixUpdateForumCategoryId} from "../panels/forumCategory/forumCategoryMapper";
import {fixUpdateForumId} from "../panels/forum/forumMapper";
import {fixUpdateSpecialistCardId} from "../panels/specialistCard/specialistCardMapper";
import {fixUpdateInvoiceId} from "../panels/invoice/invoiceMapper";
import {remapper} from "../panels/conversation/conversationMapper";
import {fixUpdateUserConversation} from "../panels/userConversation/userConversationMapper";
import {fixUpdateConversationAdId} from "../panels/conversationAd/conversationAdMapper";
import {fixUpdateAvatarId} from "../panels/avatar/avatarMapper";
import {fixUpdateExperimentId} from "../panels/experiment/experimentMapper";
import {fixUpdateVariantId} from "../panels/variant/variantMapper";
import {fixUpdateUserVariantId} from "../panels/userVariant/userVariantMapper";
import {fixUpdateChildWeekId} from "../panels/childWeek/childWeekMapper";
import {fixUpdateMarketLoginId} from "../panels/marketLogin/marketLoginMapper";
import {fixUpdateWelcomeModalId} from "../panels/welcomeModal/welcomeModalMapper";
import {fixUpdateTermsConditionId} from "../panels/termsCondition/termsConditionMapper";
import {fixUpdatePlanId} from "../panels/plan/planMapper";
import {fixUpdatePlanTypeId} from "../panels/planType/planTypeMapper";
import {fixUpdatePromotionId} from "../panels/promotion/promotionMapper";
import {fixUpdateDiscountId} from "../panels/discount/diacountMapper";
import {fixUpdateBulkDiscountId} from "../panels/bulkDiscount/bulkDiacountMapper";
import {fixUpdatePlanFeaturesId} from "../panels/planFeatures/planFeaturesMapper";
import {fixUpdateEventBannerId} from "../panels/eventBanner/eventBannerMapper";
import {fixUpdateSubscriptionId} from "../panels/subscription/subscriptionMapper";

export async function update(resource, params) {

  if (resource === 'advice' && params.data.pictures) {
    await FileUploader(resource, params, params.data.pictures);
    params.data['bannerImage'] = params.data.url;
    delete params.data.url;
    delete params.data.pictures;
  }

  if (resource === 'forum' && params.data.pictures) {
    await FileUploader(resource, params, params.data.pictures);
    params.data['icon'] = params.data.url;
    delete params.data.url;
    delete params.data.pictures;
  }

  if (resource === 'forumCategory' && params.data.pictures) {
    await FileUploader(resource, params, params.data.pictures);
    params.data['icon'] = params.data.url;
    delete params.data.url;
    delete params.data.pictures;
  }

  if (resource === 'blog' && params.data.pictures) {
    await FileUploader(resource, params, params.data.pictures);
    params.data['icon'] = params.data.url;
    delete params.data.url;
    delete params.data.pictures;
  }

  if (resource === 'planFeatures' && params.data.pictures) {
    await FileUploader(resource, params, params.data.pictures);
    params.data['icon'] = params.data.url;
    delete params.data.url;
    delete params.data.pictures;
  }

  if (resource === 'blogCategory' && params.data.pictures) {
    await FileUploader(resource, params, params.data.pictures);
    params.data['icon'] = params.data.url;
    delete params.data.url;
    delete params.data.pictures;
  }

  if (resource === 'plan' && params.data.pictures) {
    await FileUploader(resource, params, params.data.pictures);
    params.data['icon'] = params.data.url;
    delete params.data.url;
    delete params.data.pictures;
  }

  if (resource === 'conversation') {
    remapper(params.data);
    params.data['conversationId'] = params.data.objectId;
    delete params.data.objectId;
    delete params.data.createProducts;
    delete params.data.createTag;
  }

  if (resource === 'user' && params.data.files) {
    await FileUploader(resource, params, params.data.files);
    params.data['avatarUrl'] = params.data.url;
    delete params.data.url;
  }

  if (resource === 'conversationAd' && params.data.image) {
    await FileUploader(resource, params, params.data.image);
    params.data['imageUrl'] = params.data.url;
    delete params.data.url;
  }

  if (resource === 'conversationAd' && params.data.backgroundPicture) {
    await FileUploader(resource, params, params.data.backgroundPicture);
    params.data['backgroundImageUrl'] = params.data.url;
    delete params.data.url;
  }

  if (resource === 'avatar' && params.data.avatar) {
    await FileUploader(resource, params, params.data.avatar);
    params.data['avatarUrl'] = params.data.url;
    delete params.data.url;
    delete params.data.avatar;
  }

  if (resource === 'eventBanner' && params.data.pictures) {
    await FileUploader(resource, params, params.data.pictures);
    params.data['image'] = params.data.url;
    delete params.data.url;
    delete params.data.pictures;
  }

  if (resource === 'childWeek' && params.data.image) {
    await FileUploader(resource, params, params.data.image);
    params.data['imageUrl'] = params.data.url;
    delete params.data.url;
    delete params.data.image;
  }

  if (['advice', 'blog', 'blogCategory', 'forum', 'forumCategory', 'conversationAd', 'childWeek'].includes(resource)) {
    params.data.markets = params.data.adminMarkets?.map(item => item.markets);
  }

  if (['marketLogin'].includes(resource)) {
    params.data.loginTypes = params.data.adminLoginTypes?.map(item => item.loginTypes);
  }

  if (['user'].includes(resource)) {
    params.data.specialistCategory = params.data.adminSpecialistCategories?.map(item => item.category);
    delete params.data.adminSpecialistCategories;
  }

  if (resource === 'advice' || resource === 'conversationAd' || resource === "discount" || resource === "bulkDiscount") {
    params.data.expirationDate = params.data.expirationDate && new Date(params.data.expirationDate).getTime();
  }

  if (resource === "promotion") {
    params.data.startDate = params.data.startDate && new Date(params.data.startDate).getTime();
    params.data.endDate = params.data.endDate && new Date(params.data.endDate).getTime();
  }

  let url = `${SERVER}/${MAP_URL[resource]}`;
  if (['adminUsers', 'config', 'user'].includes(resource)) {
    url = url + `/${params.id}`;
  }
  if (resource === 'blogCategory') {
    let x = {...params.data, categoryId: params.data.objectId};
    params.data = x;
  }
  if (resource === 'forumCategory') {
    let x = {...params.data, objectId: params.data.objectId};
    params.data = x;
  }
  if (['promotion'].includes(resource) || ['discount'].includes(resource) || ['bulkDiscount'].includes(resource)) {
    params.data.plansId = params.data.adminPlansId?.map(item => item.plansId);
    params.data.specialistIds = params.data.adminSpecialistIds?.map(item => item.specialistIds);
    params.data.clinicCategories = params.data.adminClinicCategories?.map(item => item.clinicCategories);
    params.data.specialistCardIds = params.data.adminSpecialistCardIds?.map(item => item.specialistCardIds);
  }
  return HttpClient(url, {
    method: "PUT",
    body: JSON.stringify(params.data),
  }).then(({json}) => {
      if (resource === 'advice') {
        return fixUpdateAdviceId(json);
      } else if (resource === 'blogCategory') {
        return fixUpdateBlogCategoryId(json);
      } else if (resource === 'blog') {
        return fixUpdateBlogId(json);
      } else if (resource === 'config') {
        return fixUpdateConfigId(json);
      } else if (resource === 'forumCategory') {
        return fixUpdateForumCategoryId(json);
      } else if (resource === 'forum') {
        return fixUpdateForumId(json);
      } else if (resource === 'specialistCard') {
        return fixUpdateSpecialistCardId(json);
      } else if (resource === 'invoice') {
        return fixUpdateInvoiceId(json);
      } else if (resource === 'userConversation') {
        return fixUpdateUserConversation(json);
      } else if (resource === 'conversationAd') {
        return fixUpdateConversationAdId(json);
      } else if (resource === 'avatar') {
        return fixUpdateAvatarId(json);
      } else if (resource === 'experiment') {
        return fixUpdateExperimentId(json);
      } else if (resource === 'variant') {
        return fixUpdateVariantId(json);
      } else if (resource === 'userVariant') {
        return fixUpdateUserVariantId(json);
      } else if (resource === 'childWeek') {
        return fixUpdateChildWeekId(json);
      } else if (resource === 'marketLogin') {
        return fixUpdateMarketLoginId(json);
      } else if (resource === 'welcomeModal') {
        return fixUpdateWelcomeModalId(json);
      } else if (resource === 'termsCondition') {
        return fixUpdateTermsConditionId(json);
      } else if (resource === 'plan') {
        return fixUpdatePlanId(json);
      } else if (resource === 'planType') {
        return fixUpdatePlanTypeId(json);
      } else if (resource === 'promotion') {
        return fixUpdatePromotionId(json);
      } else if (resource === "discount") {
        return fixUpdateDiscountId(json);
      } else if (resource === "bulkDiscount") {
        return fixUpdateBulkDiscountId(json);
      } else if (resource === "planFeatures") {
        return fixUpdatePlanFeaturesId(json);
      } else if (resource === "eventBanner") {
        return fixUpdateEventBannerId(json);
      } else if (resource === "subscription") {
        return fixUpdateSubscriptionId(json);
      }

      return {
        data: {...json, id: json.phoneNumber},
      };
    }
  );
}